<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h3>Σημείωση id:  {{ $route.params.id }}</h3>

          <h4>Συντάκτης:</h4>
          <p>{{ note.author }}</p>
          <h4>Τίτλος:</h4>
          <p>{{ note.title }}</p>
          <h4>Περιεχόμενο:</h4> 
          <p>{{ note.content }}</p>
          <h4>Ημερομηνία:</h4> 
          <p>{{ note.applies_to_date | formatDate }}</p>
          <h4>Κατάσταση: </h4>
          <p>
              <CBadge :color="note.status_class">{{note.status}}</CBadge>
          </p>
          <h4>Τύπος σημείωσης:</h4>
          <p>{{ note.note_type }}</p>

          <CButton color="primary" @click="goBack">Πίσω</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import axios from 'axios';

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});

export default {
  name: 'User',
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  data: () => {
    return {
      note: [],
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    }
  },
  mounted: function(){
    let self = this;
    axios.get('/api/notes/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.note = response.data;
    }).catch(function (error) {
      console.log(error);
      self.$router.push({ path: '/login' });
    });
  }
}


</script>
